
import React from 'react';
import CodeEditor from '@uiw/react-textarea-code-editor';

import { useToken } from "./token_context";
import { useMessage } from "./message_context";
import { usePageContext } from "./page_context";

async function loadConfig(access_token) {
    if (!access_token.token) return null;
    const res = await fetch("/api/model/parameters/config?_t=" + access_token.token)
    const res_data = await res.json();
    if (res_data.rc == "ok") {
        return res_data.pp_value;
    } else {
        return null;
    };
}

async function saveConfig(access_token, code) {

    const payload = {
        _t: access_token.token,
        data: code
    };
    const res = await fetch("/api/model/parameters/config",
        {
          "method": "PUT",
          "body": JSON.stringify(payload)
        });

    const res_data = await res.json();
    return res_data;
};



export function ParametersEditForm(props) {
    const { token } = useToken();
    const { setMessage, setError } = useMessage();
    const { page_state, setPageState } = usePageContext();
    const [code, setCode] = React.useState("");


    React.useEffect(() => {
        loadConfig(token).then((config) => {
            setCode(config);
        });
    }, [ token ]);

    function onClick_OK(ev) {
        ev.preventDefault();
        try {
            const test = JSON.parse(code)
            saveConfig(token, code).then((rc) => {
                if (rc.rc == "ok") {
                    setPageState({
                        edit_parameters_dialog_open: false
                    });
                    setMessage("Parameters updated");
                };
            });
        } catch (e) {
            setError("Error while parsing JSON: " + e);
        };
    };

    function onClick_Cancel(ev) {
        ev.preventDefault();
        setPageState({
            edit_parameters_dialog_open: false
        });
    };

    if (token.permissions.includes("can_edit_parameters") && page_state.edit_parameters_dialog_open) {

    return (<div>
            <CodeEditor
              value={code}
              language="JSON"
              placeholder="Please enter parameters"
              onChange={(evn) => setCode(evn.target.value)}
              padding={15}
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
              }}
            />
            <div className="modal-action flow-root">
                <button className="btn btn-cancel mx-2 float-left" onClick={onClick_Cancel} >Cancel</button>
                <button className="btn btn-primary mx-2 float-right" onClick={onClick_OK} >OK</button>
            </div>
            </div>
    );
    };
};


